module.exports = __webpack_public_path__ + "img/why-choose-us2.6e158068.jpg";